// Browser usage-beacon client (spec 2026-09-24-stats-design §3; v2 D4/D5). Fire-and-forget POSTs
// to /api/hit: every call is wrapped in try/catch so a stats failure can never break the tool it's
// attached to. Three things skip a real hit — localhost/127.0.0.1, navigator.webdriver (our own
// Playwright/live-verification runs, D4), and the device opt-out (D5) — but the e2e opt-in
// `window.__statsEnabled === true` is checked FIRST and forces sending through all three, so
// tests can still exercise the real beacon path from a headless browser on localhost.
const OPT_OUT_KEY = 'filasophy.stats.off';

// Read inside its own try/catch (not the caller's): a throwing localStorage (private mode, quota)
// must fall back to "not opted out" and still let the hit through, never abort the whole hit().
function isOptedOut() {
  try {
    return localStorage.getItem(OPT_OUT_KEY) === '1';
  } catch {
    return false;
  }
}

export function hit(tool, event, label) {
  try {
    if (window.__statsEnabled !== true) {
      const h = location.hostname;
      if (h === 'localhost' || h === '127.0.0.1') return;
      if (navigator.webdriver === true) return;
      if (isOptedOut()) return;
    }
    const body = JSON.stringify(label === undefined ? { tool, event } : { tool, event, label });
    if (navigator.sendBeacon && navigator.sendBeacon('/api/hit', body)) return;
    fetch('/api/hit', { method: 'POST', body, keepalive: true, headers: { 'content-type': 'text/plain' } }).catch(() => {});
  } catch { /* stats never break the tool */ }
}

// The LOOKS entry whose applyLook(layers, look) colours equal the layers' current colours,
// lower-cased (e.g. 'ocean'); 'custom' when no look matches. applyLook() maps a look's 4 colours
// down to `layers.length` bands the same way for any look, so comparing its OUTPUT colours (not
// the look's raw .colors array) against the current layers is what makes this correct for 2/3/4
// layer docs alike. Since the brand-default amendment, the untouched default doc's colours ARE
// the 'Filasophy' look's, so this reports 'filasophy' for it — never a separate 'default' label.
export function lookLabel(layers, LOOKS, applyLook) {
  const up = (c) => String(c).toUpperCase();   // <input type=color> and decoded links may give lower-case hex
  const colors = layers.map(l => up(l.color));
  for (const look of LOOKS) {
    const applied = applyLook(layers, look);
    if (applied.every((l, i) => up(l.color) === colors[i])) return look.name.toLowerCase();
  }
  return 'custom';
}
